import React, { FC } from 'react';

// @tecton
import { FlexItem, Text, FlexGroupWrapper } from '@tecton/ComponentRedesign';
interface ActivateAccountProps {
  serviceAccountName: string;
}

const ActivateAccount: FC<ActivateAccountProps> = ({ serviceAccountName }) => {
  return (
    <>
      <FlexGroupWrapper gap="l" direction="column">
        <FlexItem grow={false}>
          <Text>Are you sure you want to Activate {serviceAccountName}?</Text>
        </FlexItem>
        <FlexItem grow={false}></FlexItem>
      </FlexGroupWrapper>
    </>
  );
};

export default ActivateAccount;
